<template>
  <div class="shopLists">
    <div class="flexItem shopSetDetail shopPage">
      <!-- 미리보기 -->
      <div class="detailContent">
        <!-- 상품 카테고리 -->
        <div class="shopCategory">
          <ShopPageCateogry
            v-if="category"
            :locale="locale"
            :category="category"
            :categoryId="categoryId"
            @changeCategory="isSearching = false" />
          <button
            type="button"
            class="btn"
            :disabled="message.category"
            @click="setDetail('new')">
            {{ locale.do_add_product }}
          </button>
          <div v-if="itemCount" class="shopItemsFilter">
            <span class="checkbox">
              <input type="checkbox" name="view_item_status" id="view_item_activate" value="activate" v-model="viewItems" />
              <label for="view_item_activate">{{locale.shop_activate_item}}({{ itemCount.activate }})</label>
            </span>
            <span class="checkbox">
              <input type="checkbox" name="view_item_status" id="view_item_inactivate" value="inactivate" v-model="viewItems" />
              <label for="view_item_inactivate">{{locale.shop_inactivate_item}}({{ itemCount.inactivate }})</label>
            </span>
            <input type="text" class="input" :placeholder="`${locale.search_placeholder}(name or pId)`" v-model="searchInput" />
          </div>
        </div>
        <!-- //상품 카테고리 -->
        <!-- 상품 아이템 샵페이지 -->
        <div v-if="(items.length <= 0 && message.category) || message.items || message.error" class="message">
          <p v-if="items.length <= 0 && message.category">{{ message.category }}</p>
          <p v-else-if="message.items">{{ message.items }}</p>
          <p v-else-if="message.error">{{ message.error }}</p>
          <p v-if="isBaseShopPos && categoryId !== 'call-staff'" class="connectShopMessage">{{locale.message_shop_synced_page}}<br />{{locale.message_shop_not_management_directly}}</p>
        </div>
        <draggable
          v-if="filteredItems && filteredItems.length > 0"
          v-model="filteredItems"
          tag="ul"
          :animation="200"
          :filter="'.checkbox, input, label, button'"
          :prevent-on-filter="false"
          :delay="150"
          :delay-on-touch-only="true"
          :touch-start-threshold="5"
          :style="itemGridStyle"
          :class="{hiddenDefaultThumb: settings.hiddenDefaultThumb}"
          ref="shopItems"
          class="shopItems">
          <li
            v-for="item in filteredItems"
            :key="item.shopItemId"
            class="shopItem"
            :class="{inActivate: !item.isActive}"
            @click="setDetail(item.shopItemId, $event)">
            <div class="checkbox">
              <input type="checkbox" :id="item.shopItemId" :value="item.shopItemId" v-model="checkedItem">
              <label :for="item.shopItemId"></label>
            </div>
            <div class="thumb">
              <img v-if="item.thumb" :src="item.thumb" :alt="item.name" />
              <div v-if="item.hasOption" class="optionStkr">{{ locale.option }}</div>
              <span v-if="item.isOptItem" class="isOptionItem">옵션상품</span>
            </div>
            <div v-if="item.pId" class="pId">{{ item.pId }}</div>
            <div v-if="item.title" class="title" :title="item.title">{{ item.title }}</div>
            <div class="name" :style="itemTextStyle">{{ item.shopItemName[defaultLang] }}</div>
            <div v-if="categoryId !== 'call-staff'" class="price" :style="itemPriceStyle">{{ priceFormat(displayPrice(item.priceInfo)) }}</div>
          </li>
        </draggable>
        <!-- //상품 아이템 샵페이지 -->
        <!-- 선택 및 일괄 설정 -->
        <div class="selectItems">
          <div class="checkbox">
            <input type="checkbox" :id="`${categoryId}_select_all`" v-model="checkedAllItems">
            <label :for="`${categoryId}_select_all`">{{ locale.all }}</label>
          </div>
          <div class="selectLabel">
            <strong>{{ checkedItem.length }}</strong>
            <span class="colorGrey"> / {{ filteredItems.length }} {{ locale.selected }}</span>
          </div>
          <button
            type="button"
            class="btn btnWhite sizeS ml15"
            :disabled="checkedItem.length === 0"
            @click="setBulkItems(true)">
            {{ locale.bulk_edit_selected_items }}
          </button>
          <button
             type="button"
            class="btn btnWhite sizeS btnSetOrder"
            @click="setShopItemIndex(null, true)">
            {{locale.save_order}}
          </button>
          <button
            type="button"
            class="btn btnWhite sizeS btnSearchItem"
            @click="itemListAll = true">
            {{ locale.find_item }}
          </button>
          <button
            type="button"
            class="btn btnWhite sizeS btnSetCategory"
            @click="setCategorySettings(true)">
            {{ locale.category_setting }}
          </button>
        </div>
        <!-- //선택 및 일괄 설정 -->
      </div>
      <!-- //미리보기 -->
      <!-- 샵페이지 설정 -->
      <div class="detailSetting">
        <!-- 상품간격 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">{{locale.product_spacing}}</label>
          <p class="sysMessage">{{ locale.message_shop_spacing_narrower }}</p>
          <div class="mb5">
            <label>{{locale.vertical}}</label>
            <InputRange
              :min="1"
              :max="5"
              :step="1"
              :minLabel="locale.narrow"
              :maxLabel="locale.wide"
              :value="settings.itemMarginTb"
              @setRange="setRange('itemMarginTb', $event)" />
          </div>
          <div class="mb5">
            <label>{{locale.horizontal}}</label>
            <InputRange
              :min="1"
              :max="5"
              :step="1"
              :minLabel="locale.narrow"
              :maxLabel="locale.wide"
              :value="settings.itemMarginLr"
              @setRange="setRange('itemMarginLr', $event)" />
          </div>
        </div>
        <!-- //상품간격 -->
        <!-- 글자크기 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">{{locale.font_size}}</label>
          <div class="mb5">
            <label>{{locale.product_name}}</label>
            <InputRange
              :min="1"
              :max="5"
              :step="1"
              :minLabel="locale.small"
              :maxLabel="locale.large"
              :value="settings.itemFontSize"
              @setRange="setRange('itemFontSize', $event)" />
          </div>
          <div class="mb5">
            <label>{{locale.product_price}}</label>
            <InputRange
              :min="1"
              :max="5"
              :step="1"
              :minLabel="locale.small"
              :maxLabel="locale.large"
              :value="settings.itemPriceSize"
              @setRange="setRange('itemPriceSize', $event)" />
          </div>
        </div>
        <!-- //글자크기 -->
        <!-- 글자 정렬 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">{{locale.text_align}}</label>
          <div class="mb15">
            <label>{{locale.product_name}}</label>
            <div class="btnRadio">
              <span
                v-for="(align, index) in alignSetting"
                :key="index"
                class="radioSelector">
                <input
                  type="radio"
                  name="align_name"
                  :id="`align_name_${align}`"
                  :value="align"
                  v-model="settings.itemAlignName">
                <label
                  :for="`align_name_${align}`"
                  :class="`align_${align}`">
                </label>
              </span>
            </div>
          </div>
          <div class="mb5">
            <label>{{locale.product_price}}</label>
            <div class="btnRadio">
              <span
                v-for="(align, index) in alignSetting"
                :key="index"
                class="radioSelector">
                <input
                  type="radio"
                  name="align_price"
                  :id="`align_price_${align}`"
                  :value="align"
                  v-model="settings.itemAlignPrice">
                <label
                  :for="`align_price_${align}`"
                  :class="`align_${align}`">
                </label>
              </span>
            </div>
          </div>
        </div>
        <!-- //글자 정렬 -->
        <!-- 카테고리 구분 숨기기 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">카테고리 구분</label>
          <div class="checkbox mb10">
            <input type="checkbox" id="hidden_category_group" v-model="settings.hiddenCategoryGroup">
            <label for="hidden_category_group">카테고리 구분 미노출</label>
          </div>
          <p class="sysMessage">상품 리스트에서 카테고리를 구분하는 카테고리명을 노출하지 않습니다.</p>
        </div>
        <!-- //카테고리 구분 숨기기 -->
        <!-- 옵션 필수선택 표시 숨기기 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">옵션 필수선택 표시</label>
          <div class="checkbox mb10">
            <input type="checkbox" id="hidden_option_requirement" v-model="settings.hiddenOptionRequirement">
            <label for="hidden_option_requirement">옵션 필수선택 표시 미노출</label>
          </div>
        </div>
        <!-- //옵션 필수선택 표시 숨기기 -->
        <!-- 이용시간 외 상품 미노출 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">{{ locale.off_hours_items }}</label>
          <div class="checkbox">
            <input type="checkbox" id="hidden_not_availabletime" v-model="settings.hiddenAvailableTime">
            <label for="hidden_not_availabletime">{{ locale.items_hidden }}</label>
          </div>
        </div>
        <!-- //이용시간 외 상품 미노출 -->
         <!-- 썸네일 이미지 숨기기 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">썸네일 기본 이미지 표시</label>
          <div class="checkbox mb10">
            <input type="checkbox" id="hidden_default_thumb" v-model="settings.hiddenDefaultThumb">
            <label for="hidden_default_thumb">썸네일 기본 이미지 미노출</label>
          </div>
        </div>
        <!-- //옵션 필수선택 표시 숨기기 -->
        <!-- 직원호출 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">{{ locale.enable_staff_call }}</label>
          <div class="checkbox">
            <input type="checkbox" id="use_call_staff" v-model="isUseCallStaff">
            <label for="use_call_staff">{{ locale.enabled }}</label>
          </div>
        </div>
        <!-- //직원호출 -->
        <!-- 금액표시 -->
        <div v-if="isBaseShopPos" class="formGroup mb30">
          <label class="label groupLabel mb5">순금액(세금·봉사료 제외)으로 표시</label>
          <div class="checkbox">
            <input type="checkbox" id="exclude_tax" v-model="excludeTax">
            <label for="exclude_tax">{{ locale.enabled }}</label>
          </div>
        </div>
        <!-- //금액표시 -->
         <!-- 주문전용 -->
        <div class="formGroup mb30">
          <label class="label groupLabel mb5">주문 전용(주문내역 확인 불가)</label>
          <div class="checkbox">
            <input type="checkbox" id="disabled_myorder" v-model="settings.disabledMyOrder">
            <label for="disabled_myorder">{{ locale.enabled }}</label>
          </div>
        </div>
        <!-- //주문전용 -->
      </div>
      <!-- //샵페이지 설정 -->
      <!-- 샵페이지 정보 -->
      <div class="detailInfo">
        <div class="formGroup mb30">
          <button type="button" class="btn btnFull btnPrimary toUppercase" :disabled="message.category" @click.stop="savePage">{{ locale.save }}</button>
        </div>

        <div v-if="isSuperadmin || isSiteadmin" class="formGroup mb30">
          <button type="button" class="btn btnFull btnRed toUppercase" @click="deletePage">{{ locale.delete }}</button>
        </div>

        <div class="formGroup mb15 dupShop">
          <button type="button" class="btn btnFull btnWhite toUppercase" :class="{isOpen: setDuplicate}" @click="setDuplicate = !setDuplicate">{{ locale.shop_duplicate }}</button>
          <div v-if=setDuplicate class="dupOptions">
            <div>
              <div class="checkbox">
                <input type="checkbox" id="duplicate_shop_option" v-model="duplicateOption">
                <label for="duplicate_shop_option">{{ locale.duplicate_include_shop_option}}</label>
              </div>
            </div>
            <div class="mb5">
              <div class="checkbox">
                <input type="checkbox" id="duplicate_shop_category" v-model="duplicateCategory">
                <label for="duplicate_shop_category">{{ locale.duplicate_include_shop_category }}</label>
              </div>
            </div>
            <button type="button" class="btn btnFull toUppercase" @click="duplicateShopPage">{{ locale.do_duplicate }}</button>
          </div>
        </div>

        <!-- 벌크 업로드 -->
        <div v-if="!isBaseShopPos && isSuperadmin" class="formGroup mb30">
          <button type="button" class="btn btnFull btnLightGrey" @click="openBulkItem">벌크 업로드</button>
        </div>
        <!-- //벌크 업로드 -->

        <div v-if="isBaseShopPos" class="formGroup mb30">
          <button type="button" class="btn btnFull btnWhite toUppercase" @click="requestSync">{{locale.do_sync_data}}</button>
        </div>
        <div class="formGroup mb30">
          <label class="label setLabel mb5">{{ locale.name }}</label>
          <input type="text" class="input" v-model="name">
        </div>
        <div class="formGroup mb30">
          <label class="label setLabel mb5">{{ locale.category }}</label>
          <button type="button" class="btn btnWhite btnFull toUppercase" @click="openShopCategory">{{ locale.setting }}</button>
        </div>
        <div class="formGroup mb30">
          <label class="label setLabel mb5">{{ locale.admin_codelist }}</label>
          <select class="input select" v-model="catCode">
            <option
              v-for="(code, index) in catCodeList"
              :key="index"
              :value="code.id"
              :disabled="isBaseShopPos && (code.id !== catCode)">
              {{ code.id === 'system_shop_service' ? locale.system_shop_service : code.label }}
            </option>
          </select>
        </div>
        <!-- 이용 인원 설정 -->
        <div class="formGroup mb30">
          <label class="label setLabel mb5">{{ locale.guest_count }}</label>
          <button type="button" class="btn btnWhite btnFull toUppercase" @click="setGuestCount(true)">{{ locale.setting }}</button>
        </div>
        <!-- //이용 인원 설정 -->
        <!-- 주문 제한 설정 -->
        <div class="formGroup mb30">
          <label class="label setLabel mb5">{{ locale.order_limits }}</label>
          <button type="button" class="btn btnWhite btnFull toUppercase" @click="setOrderLimit(true)">{{ locale.setting }}</button>
        </div>
        <!-- //주문 제한 설정 -->
      </div>
      <!-- //샵페이지 정보 -->
      <!-- 구성상품 레이어 -->
      <CompositeItem v-if="detail"
        :locale="locale"
        :shopPageId="pageId"
        :catCode="catCode"
        :shopItemId="detail"
        :defaultLang="defaultLang"
        :isBaseShopPos="isBaseShopPos"
        :categoryList="category"
        @completeSave="saveItem"
        @completeDelete="deleteItem"
        @close="setDetail(null)" />
      <!-- //구성상품 레이어 -->
      <!-- 카테고리 설정 -->
      <ShopCategory v-if="shopCategory"
        :locale="locale"
        :id="id"
        :catCode="catCode"
        :categoryId="categoryId"
        :defaultLang="defaultLang"
        :isBaseShopPos="isBaseShopPos"
        :category="category"
        @reload="getShopCategory"
        @close="closeShopCategory" />
      <!-- //카테고리 설정 -->
      <!-- 인원 설정 -->
      <ShopGuestCount v-if="guestCount"
        :locale="locale"
        :defaultLang="defaultLang"
        :pageId="pageId"
        :catCode="catCode"
        @close="setGuestCount(null)"
        @apply="applyGuestCount" />
      <!-- //인원 설정 -->
      <!-- 샵 제한 설정 -->
      <ShopOrderLimit v-if="orderLimit"
        :locale="locale"
        :defaultLang="defaultLang"
        :pageId="pageId"
        @close="setOrderLimit(false)" />
      <!-- //샵 제한 설정 -->
      <!-- 카테고리 제한 설정 -->
      <CategorySetting v-if="categorySettings"
        :locale="locale"
        :defaultLang="defaultLang"
        :catCode="catCode"
        :pageId="pageId"
        :categoryId="categoryId"
        @close="setCategorySettings(false)" />
      <!-- //제한 설정 -->
      <!-- 일괄 변경 -->
      <SetBulkItems v-if="bulkItems"
        :locale="locale"
        :shopPageId="pageId"
        :shopItemIds="checkedItem"
        :shopOptIds="checkedOptItem"
        :defaultLang="defaultLang"
        :categoryList="category"
        :checkedIds="[categoryId]"
        @close="setBulkItems(null)"
        @complete="completeBulkUpdate" />
      <!-- //일괄 변경 -->
    </div>
    <ItemListAll
      v-if="itemListAll"
      :locale="locale"
      @apply="findItem"
      @close="itemListAll = false" />
    <UploadItem v-if="uploadItem"
      :locale="locale"
      :shopPageId="pageId"
      :categoryId="categoryId"
      :defaultLang="defaultLang"
      :categoryList="category"
      @complete="getShopItems()"
      @close="uploadItem = false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import InputRange from '@/components/Util/InputRange'
import CompositeItem from './CompositeItem'
import ShopCategory from './ShopCategory'
import ShopPageCateogry from './ShopPageCateogry'
import ShopGuestCount from './GuestCount'
import ShopOrderLimit from './OrderLimit'
import CategorySetting from './ShopCategorySetting'
import SetBulkItems from './SetBulkItems'
import ItemListAll from './ItemListAll'
import UploadItem from './UploadItem'

export default {
  name: 'ShopPage',
  props: [
    'locale',
    'id',
    'categoryId'
  ],
  components: {
    draggable,
    InputRange,
    CompositeItem,
    ShopCategory,
    ShopPageCateogry,
    ShopGuestCount,
    ShopOrderLimit,
    CategorySetting,
    SetBulkItems,
    ItemListAll,
    UploadItem
  },
  computed: {
    isSuperadmin () {
      return this.$store.getters['authentication/getAuthority']
    },
    isSiteadmin () {
      return this.$store.getters['authentication/getAuthoritySite']
    },
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    catCodeList () {
      return this.$store.getters['admin/shopCodeList']
    },
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    },
    pageId () {
      return this.$route.params.id
    },
    itemGridStyle () {
      const marginTb = (parseInt(this.settings.itemMarginTb) - 1) * 0.6 + 1.4
      const marginlr = (parseInt(this.settings.itemMarginLr) - 2) * 0.4 + 1
      const tb = this.settings && this.settings.itemMarginTb ? marginTb : 4
      const lr = this.settings && this.settings.itemMarginLr ? marginlr : 3
      return {
        gridRowGap: `${tb}em`, // 4(1.8em)
        gridColumnGap: `${lr}em` // 3(1.4em)
      }
    },
    itemTextStyle () {
      const fontSize = 1 + (parseInt(this.settings.itemFontSize) - 3) * 0.1 // default: 3(1em)
      const align = this.settings.itemAlignName
      return {
        fontSize: `${fontSize}em`,
        textAlign: align
      }
    },
    itemPriceStyle () {
      const fontSize = 1 + (parseInt(this.settings.itemPriceSize) - 3) * 0.1 // default: 3(1em)
      const align = this.settings.itemAlignPrice
      return {
        fontSize: `${fontSize}em`,
        textAlign: align
      }
    },
    itemIndexIds () {
      const list = this.items
      return list.map(x => x.shopItemId)
    },
    diffItemIndex () {
      const origin = this.originItemIndex
      const current = this.itemIndexIds
      function isExactlySameArray(arr1, arr2) {
        if (arr1.length !== arr2.length) return false
        return arr1.every((val, idx) => val === arr2[idx])
      }
      return !isExactlySameArray(origin, current)
    },
    itemCount () {
      const items = this.items
      return items && items.length ? {
        activate: items.filter(x => x.isActive).length,
        inactivate: items.filter(x => !x.isActive).length
      } : null
    },
    filteredItems: {
      get () {
        const filteredActivate = this.items?.filter(x =>
          (this.viewItems.includes('activate') && x.isActive) ||
          (this.viewItems.includes('inactivate') && !x.isActive)
        )
        const filteredWord = regExp.replaceAllEmpty(this.searchInput)
        function matchesSearch(item, searchInput) {
          // shopItemId 또는 title 또는 pId에 포함되면 리턴
          if (
            regExp.replaceAllEmpty(item.title).includes(searchInput) ||
            regExp.replaceAllEmpty(item.shopItemId).includes(searchInput) ||
            regExp.replaceAllEmpty(item.pId).includes(searchInput)
          ) {
            return true
          }
          // shopItemName 객체의 모든 값에 대해 포함되는 부분이 있으면 리턴
          for (const lang in item.shopItemName) {
            if (regExp.replaceAllEmpty(item.shopItemName[lang]).includes(searchInput)) {
              return true
            }
          }
          // 일치 항목이 없음
          return false
        }
        return filteredActivate.filter(item => {
          return filteredWord.length > 0
            ? matchesSearch(item, filteredWord)
            : true
        })
      },
      set (list) {
        // 변경할때마다 저장
        this.items = list
        this.setShopItemIndex(null)
      }
    },
    checkedOptItem () {
      const checkedIds = this.checkedItem || []
      return this.items.filter(item => item.isOptItem && checkedIds.includes(item.shopItemId)).map(item => item.shopItemId)
    }
  },
  watch: {
    categoryId: {
      immediate: true,
      async handler (newVal, oldVal) {
        if (!newVal) return
        await this.getShopItems()
        this.viewItems = ['activate', 'inactivate']
        if (!this.isSearching) this.searchInput = ''
        this.checkedItem = []
        this.checkedAllItems = false

        this.$nextTick(() => {
          const el = this.$refs.shopItems?.$el
          if (el) {
            el.scrollTop = 0
          }
        })
      }
    },
    checkedAllItems (isCheckAll) {
      this.checkedItem = isCheckAll ? this.filteredItems.map(item => item.shopItemId) : []
    },
    excludeTax (excludeTax) {
      this.$store.commit('shop/setShopProperty', { 
        pageId: this.pageId,
        key: 'excludeTax',
        value: excludeTax
      })
    }
  },
  created () {
    this.init()
  },
  async beforeRouteLeave (to, from, next) {
    if (this.diffItemIndex) {
      await this.setShopItemIndex(null)
    }
    if (this.readyOut) {
      next()
    } else {
      const tryLogout = to.name === 'login'
      if (!tryLogout) {
        if (window.confirm(`${this.locale.confirm_leave}\n${this.locale.warn_leave}`)) {
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    }
  },
  data () {
    return {
      uploadItem: false,
      readyOut: false,
      itemListAll: false,
      name: '',
      catCode: '',
      items: [],
      originItemIndex: [],
      settings: {
        itemMarginTb: 4, // 1~5
        itemMarginLr: 3, // 1~5
        itemFontSize: 3, // 1~5
        itemPriceSize: 3, // 1~5
        itemAlignName: 'left', // left, center, right
        itemAlignPrice: 'right', // left, center, right
        hiddenAvailableTime: false,
        hiddenCategoryGroup: false,
        hiddenOptionRequirement: false,
        hiddenDefaultThumb: false,
        disabledMyOrder: false,
      },
      isUseCallStaff: false,
      excludeTax: false,
      alignSetting: [
        'left',
        'center',
        'right'
      ],
      shopCategory: false,
      category: null,
      isBaseShopPos: false, // 연동 데이터인 경우 편집제한할 부분이 많아짐
      detail: null,
      message: {
        category: null,
        items: null,
        error: null
      },
      viewItems: ['activate', 'inactivate'],
      searchInput: '',
      optionList: [],
      shopCurrency: null,
      guestCount: false,
      orderLimit: false,
      checkedItem: [],
      checkedAllItems: false,
      bulkItems: null,
      categorySettings: false,
      setDuplicate: false,
      duplicateCategory: true,
      duplicateOption: true,
      isSearching: false
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      await this.getShopPage()
      await this.getShopCategory()
      await this.getOptionListAll()
      this.setDuplicate = false
      this.viewItems = ['activate', 'inactivate']
      this.$store.commit('onLoading', false)
    },
    async getShopPage () {
      const getPage = await this.$store.dispatch('shop/getShopPage', this.pageId)
      const pageInfo = getPage && getPage.message
      if (pageInfo && pageInfo.pageId) {
        this.name = pageInfo.pageName,
        this.catCode = pageInfo.catCode
        this.isBaseShopPos = pageInfo.isBaseShopPos || false
        this.isUseCallStaff = pageInfo.isUseCallStaff || false
        this.settings = {
          ...this.settings,
          ...pageInfo.settings
        }
        this.excludeTax = pageInfo.excludeTax || false
        this.shopCurrency = pageInfo.currencyCode || null
      }
    },
    async getShopCategory () {
      const getCategory = await this.$store.dispatch('shop/getShopCategory', this.pageId) || []
      const categories = getCategory?.message?.categories

      const removeEmptySubCategory = (arr) => {
        return arr.map(({ subCategory, ...rest }) => {
          return subCategory && subCategory.length
            ? { ...rest, subCategory: removeEmptySubCategory(subCategory) }
            : rest
        })
      }

      const extraCategories = [
        {
          categoryId: 'call-staff',
          categoryLabel: 'call-staff'
        },
        {
          categoryId: 'unknown',
          categoryLabel: this.$store.getters['setting/getLangValues']('unknown')
        }
      ]

      if (categories && categories.length > 0) {
        const normalizedCategories = removeEmptySubCategory(categories)

        // 실제 API 카테고리 + 로컬 카테고리 합치기
        this.category = normalizedCategories.concat(extraCategories)
        this.message.category = null

        // 초기 진입 기본값 계산은 실제 카테고리만 기준
        const firstMain = normalizedCategories[0]
        const firstLeafId = firstMain?.subCategory?.[0]?.categoryId || firstMain?.categoryId || ''

        let nextCategoryId = this.categoryId

        if (!this.categoryId) {
          nextCategoryId = firstLeafId
        } else {
          const currentMain = normalizedCategories.find(x => x.categoryId === this.categoryId)
          if (currentMain?.subCategory?.length) {
            nextCategoryId = currentMain.subCategory[0].categoryId
          }
        }

        if (nextCategoryId && nextCategoryId !== this.categoryId) {
          this.$router.replace({
            params: {
              ...this.$route.params,
              categoryId: nextCategoryId
            }
          })
        }

        return nextCategoryId
      } else {
        // 실제 카테고리가 없어도 로컬 카테고리는 유지
        this.category = extraCategories
        this.message.category = this.locale.please_create_category

        if (this.categoryId !== 'unknown') {
          this.$router.replace({
            params: {
              ...this.$route.params,
              categoryId: 'unknown'
            }
          })
        }

        return 'unknown'
      }
    },
    async getShopItems () {
      if (this.categoryId) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/getShopItems', {
          pageId: this.pageId,
          categoryId: this.categoryId
        })
        const items = res?.message?.shopItems
        this.items = []
        this.message.items = null
        this.message.error = null
        this.message.category = null
        if (items) {
          this.items = items.map(x => {
            return {
              isActive: x.isActive,
              isOptItem: x.isOptItem,
              shopItemId: x.shopItemId,
              shopItemName: x.shopItemName,
              title: x.title || '',
              priceInfo: x.priceInfo,
              thumb: x.thumb,
              hasOption: x.hasOption || false,
              ...x.pId && {
                pId: x.pId
              }
            }
          })
          this.message.error = null
          this.message.items = items.length > 0 ? null : this.categoryId === 'unknown'
            ? this.locale.shop_no_items
            : this.locale.shop_message_add_items
          this.originItemIndex = this.items.map(x => x.shopItemId)
        } else {
          const status = (res && res.message && res.message.code) || 500
          const message = this.getShopResultData(status)
          if (status !== 406) {
            alert(message)
          }
          this.message.error = message
        }
        this.message.category = null
        this.$store.commit('onLoading', false)
      }
    },
    async getOptionListAll () {
      const getList = await this.$store.dispatch('shop/getShopStoreOptionList')
      const list = getList && getList.message && getList.message.option
      if (list) {
        this.optionList = list
      }
    },
    async setShopItemIndex (categoryId) {
      const data = {
        pageId: this.id,
        categoryId: categoryId || this.categoryId,
        shopItemIndex: this.itemIndexIds
      }
      const res = await this.$store.dispatch('shop/setShopItemIndex', data)
      if (res?.status !== 200) {
        const status = (res?.message?.code) || 500
        const message = this.getShopResultData(status)
        alert(message)
      }
    },
    async findItem (item) {
      const res = await this.$store.dispatch('shop/getShopItem', {
        pageId: item.pageId,
        shopItemId: item.shopItemId
      })
      const itemData = res?.message
      if (itemData?.shopItemId) {
        const categoryId = (itemData.category || [])[0]?.categoryId
        const searchInput = itemData.pId || itemData.shopItemName[this.defaultLang]
        if (categoryId) {
          this.isSearching = true
          this.$router.push({
            params: {
              ...this.$route.params,
              categoryId: categoryId
            }
          })
          this.searchInput = searchInput
        }
      } else {
        alert(this.locale.system_error)
      }
    },
    displayPrice (priceInfo) {
      const excludeTax = this.excludeTax
      return excludeTax ? priceInfo?.net : priceInfo?.gross
    },
    priceFormat (price) {
      const currency = this.shopCurrency || this.$store.getters['setting/getCurrencyCode']
      const disabledSymbol = this.$store.getters['setting/getData']?.currency?.disabledCurrencySymbol ?? false
      return regExp.priceFormat(price, currency.toUpperCase(), disabledSymbol)
    },
    setRange (target, value) {
      this.settings[target] = value
    },
    setDetail (shopItemId, event) {
      if (event && event.target && event.target.closest('.checkbox')) {
        event.stopPropagation()
      } else {
        this.detail = shopItemId
      }
    },
    async saveItem (shopItemId) {
      this.setDetail(shopItemId)
      // await this.setShopItemIndex(this.categoryId)
      this.getShopItems()
    },
    deleteItem () {
      this.setDetail(null)
      this.getShopItems()
    },
    openShopCategory () {
      this.shopCategory = true
    },
    closeShopCategory () {
      this.shopCategory = false
    },
    setGuestCount (isSetting) {
      this.guestCount = isSetting || false
    },
    applyGuestCount (data) {
      this.setGuestCount(null)
    },
    setOrderLimit (isSetting) {
      this.orderLimit = isSetting || false
    },
    applyOrderLimit (data){
      this.setOrderLimit(null)
    },
    openBulkItem () {
      this.category?.length > 0 ? this.uploadItem = true : alert('카테고리를 한개 이상 만들어야 합니다.')
    },
    setBulkItems (isSetting) {
      this.bulkItems = isSetting || null
    },
    setCategorySettings (isSetting) {
      this.categorySettings = isSetting || false
    },
    async completeBulkUpdate () {
      this.setBulkItems(null)
      this.checkedItem = []
      this.checkedAllItems = false
      this.$store.commit('onLoading', true)
      await this.getShopItems()
      this.$store.commit('onLoading', false)
    },
    async requestSync () {
      if (window.confirm(this.locale.confirm_sync_data)) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/requestSyncPos', this.id)
        if (res) {
          alert(this.locale.alert_complete_sync_data)
          this.$store.commit('onLoading', false)
          this.init()
        } else {
          const status = (res && res.message && res.message.code) || 500
          const message = this.getShopResultData(status)
          alert(message)
        }
        this.$store.commit('onLoading', false)
      }
    },
    async deletePage () {
      if (window.confirm(this.locale.confirm_delete_shop_page)) {
        this.readyOut = true
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/deleteShopPage', this.id)
        if (res) {
          alert(this.locale.complete_delete)
          this.$store.commit('onLoading', false)
          this.$router.replace({name: 'shopList'})
        } else {
          const status = (res && res.message && res.message.code) || 500
          const message = this.getShopResultData(status)
          alert(message)
        }
        this.$store.commit('onLoading', false)
      }
    },
    async duplicateShopPage () {
      if (!window.confirm('이 샵을 복제하여 새로운 샵을 생성하시겠습니까?')) return
      this.$store.commit('onLoading', true)
      const data = {
        pageName: `${this.name} copy`,
        targetPageId: this.pageId,
        includeCategory: this.duplicateCategory,
        includeOption: this.duplicateOption
      }
      const res = await this.$store.dispatch('shop/copyShopPage', data)
      const pageId = res && res.message && res.message.pageId
      this.$store.commit('onLoading', false)
      if (pageId) {
        this.$router.push({
          name: 'shopPage',
          params: {
            id: pageId
          }
        })
        alert('복제가 완료되었습니다.')
        this.$nextTick()
        this.init()
      } else {
        alert(this.alert_system_error)
      }
    },
    async savePage () {
      if (window.confirm(this.locale.confirm_save_shop_page)) {
        const data = {
          pageId: this.id,
          catCode: this.catCode,
          pageName: this.name,
          isUseCallStaff: this.isUseCallStaff,
          excludeTax: this.excludeTax,
          settings: {
            hiddenAvailableTime: this.settings.hiddenAvailableTime,
            hiddenCategoryGroup: this.settings.hiddenCategoryGroup,
            hiddenOptionRequirement: this.settings.hiddenOptionRequirement,
            hiddenDefaultThumb: this.settings.hiddenDefaultThumb,
            itemMarginTb: this.settings.itemMarginTb,
            itemMarginLr: this.settings.itemMarginLr,
            itemFontSize: this.settings.itemFontSize,
            itemPriceSize: this.settings.itemPriceSize,
            itemAlignName: this.settings.itemAlignName,
            itemAlignPrice: this.settings.itemAlignPrice,
            disabledMyOrder: this.settings.disabledMyOrder,
          }
        }
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/updateShopPage', data)
        if (res) {
          alert(this.locale.complete_save)
          await this.init()
          this.$store.commit('onLoading', false)
        } else {
          const status = (res && res.message && res.message.code) || 500
          const message = this.getShopResultData(status)
          alert(message)
        }
        this.$store.commit('onLoading', false)
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 1080px;
  }
  .shopItemList {
    max-height: 100%;
    overflow: auto;
  }
  .btns {
    margin-top: 30px;
    text-align: center;
  }
}
.dupShop {
  position: relative;
  z-index: 1;
}
.dupOptions {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  padding: 12px;
  border: 1px solid $color-lgrey2;
  border-top: none;
  border-radius: 4px;
  background-color: $color-white;
  box-shadow: 0 5px 10px rgba(0,0,0,0.15);
}
</style>
